export default __webpack_public_path__ + "static/media/Ellipse 24 (1).7f5e4d05.png";